import { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { getStyles } from "./Partners.styles";
import "react-multi-carousel/lib/styles.css";

const Partners = () => {
  const styles = getStyles();

  const partnerLogos = [
    { src: "/assets/images/partners/all-partners.png", alt: "partners" },
  ];

  const duplicatedLogos = [...partnerLogos, ...partnerLogos];

  //---------Animation---------
  const ref = useRef<HTMLDivElement>(null);
  const scrollRef = useRef(0);
  const speed = 0.5;
  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    const animate = () => {
      if (!container) return;

      scrollRef.current += speed;
      if (scrollRef.current >= container.scrollWidth / 2) {
        scrollRef.current = 0;
      }

      container.scrollLeft = scrollRef.current;
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    return () => {}; 
  }, []);

  return (
    <Box sx={styles.partnersContainer}>
      <Box sx={styles.partnersSection}>
        <Typography variant="h2" component="h2">
          Parteneri
        </Typography>

        <Box
          sx={styles.carouselWrapper}
          role="region"
          aria-label="Partner logos carousel"
          ref={ref}
        >
          <Box sx={styles.carouselContainer}>
            {duplicatedLogos.map((partner, index) => (
              <Box key={`${partner.alt}-${index}`} sx={styles.carouselItem}>
                <img
                  src={partner.src}
                  alt={partner.alt}
                  className="partners"
                  loading="lazy"
                  draggable={false}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Partners;
